<template>
  <v-app id="inspire" style="background-color: #21343b; overflow: hidden">
    <side-bar
      ref="sideBar"
      :drawer.sync="drawer"
      v-if="$store.getters.selectedWsInfo"
      @openDialog="openDialog"
      @closeDrawer="closeDrawer"
      @setDrawer="setDrawer"
    ></side-bar>
    <!-- 하단 main에 스타일 빼줬음.. 혹시 모르니 주석 style="width: 100%; max-width: 1785px"  -->
    <v-main class="container-main" style="width: auto">
      <v-app-bar v-if="!isInIframe" app color="#21343b" elevation="0" height="55" class="mx-auto">
        <v-app-bar-nav-icon
          v-if="$store.getters.selectedWsInfo"
          class="app-bar-icon"
          style="position: absolute"
          @click="closeDrawer"
          dark
        ></v-app-bar-nav-icon>
        <search-header
          v-if="
            $route.name === 'ChannelMeeting' ||
            $route.name === 'ChannelMeetingShare' ||
            $route.name === 'ChannelMeetingAssigned'
              ? ($store.getters.currentMt && $store.getters.currentMt.mtTopic !== null) ||
                ($store.getters.currentMt && $store.getters.currentMt.mtTopic !== undefined)
              : true
          "
          @openDialog="openDialog"
          @openManage="openDialog"
          @openSlot="openDialog"
          @close="closeDialog"
        ></search-header>
        <!-- <search-header
          v-if="$store.getters.selectedWsInfo || computedSelectedCh['chCategory'] === 'inbox'"
          :mtInfo.sync="$store.getters.currentMt"
          @openDialog="openDialog"
          @openManage="openDialog"
          @openSlot="openDialog"
          @close="closeDialog"
        ></search-header>
        <public-header
          v-else
          :mtInfo.sync="$store.getters.currentMt"
          @openDialog="openDialog"
          @openManage="openDialog"
          @openSlot="openDialog"
          @close="closeDialog"
        ></public-header> -->
      </v-app-bar>
      <slot name="content"></slot>
    </v-main>

    <floating-controller></floating-controller>
    <setting-dialog
      v-if="settingVisible"
      :settingVisible.sync="settingVisible"
      :menuType="menuType"
      @openManage="openDialog"
      @openSlot="openDialog"
      @close="closeDialog"
    ></setting-dialog>
    <manage-dialog v-if="manageVisible" @close="closeDialog" :manageVisible.sync="manageVisible"></manage-dialog>
    <slot-dialog v-if="slotVisible" @close="closeDialog" :slotVisible.sync="slotVisible"></slot-dialog>
    <leave-dialog v-if="isLeaveDialog" @closeDialog="closeDialog" :isLeaveDialog.sync="isLeaveDialog"></leave-dialog>
    <loading-dialog></loading-dialog>
    <!-- <div
      style="z-index: 300; position: fixed; width: 100%; height: 100%"
      v-if="chk_isLoading"
      class="container-skeleton"
    >
      <v-skeleton-loader class="" type="table-heading" dark></v-skeleton-loader>
      <v-skeleton-loader class="" type="card" dark></v-skeleton-loader>
    </div> -->
  </v-app>
</template>

<script>
import SettingDialog from '@/views/modal/SettingDialog'
import SideBar from '@/views/meeting/component/SideBar'
import SearchHeader from '@/views/meeting/component/SearchHeader'
// import PublicHeader from '@/views/meeting/component/PublicHeader'
import ManageDialog from '@/views/modal/ManageDialog'
import SlotDialog from '@/views/modal/SlotDialog'
import LoadingDialog from '@/views/modal/LoadingDialog'
import LeaveDialog from '@/views/modal/leaveDialog'
import { isChrome } from '@/common/lib/strLib'
import { mapGetters } from 'vuex'
import FloatingController from '@/views/meeting/component/FloatingController'
// import { chkWsDomain } from '@/services/api'
// import Toast from '@/views/meeting/component/Toast'
import { getUserToken } from '@/services/api'

export default {
  components: {
    LeaveDialog,
    LoadingDialog,
    SlotDialog,
    ManageDialog,
    SideBar,
    SearchHeader,
    SettingDialog,
    FloatingController,
  },
  created() {
    this.wsDomain = this.$route.params.wsDomain
    // this.chkDomain()
    let openPref = this.$store.getters.openPref
    if (openPref && openPref !== null && openPref !== '') {
      switch (openPref) {
        case 'emailPref':
          this.settingVisible = true
          this.menuType = 'NOTI'
          break
        case 'plan':
          this.settingVisible = true
          this.menuType = 'PLANBILLING'
          break
        default:
          break
      }
    }
  },
  mounted() {
    // console.log(this.$root.$refs.SearchHeader)

    window.addEventListener('message', (event) => {
      // console.log('Received message from the extension:', event)
      // 메세지가 익스텐션으로 온 것 인지 확인
      if (event.data && event.data.type === 'FROM_EXTENSION') {
        // console.log('Received message from the extension:', event.data.data)
        this.$root.$refs.SearchHeader.wsUpgrade()
      }
    })

    if (isChrome() === 'Chrome') {
      this.sendMessageToTape()
    }

    this.resetScroll()

    // Transcript, summary 를 위한 웹소켓 연결
    this.$store.dispatch('connectWebsocket')
  },
  beforeDestroy() {
    // Transcript, summary 를 위한 웹소켓 연결
    // this.$store.dispatch('disConnectWebsocket')
  },
  data: () => ({
    mtOrganizerUid: '',
    settingVisible: false,
    manageVisible: false,
    slotVisible: false,
    selection: 1,
    alignments: ['start', ''],
    wsDomain: '',
    isLeaveDialog: false,
    drawer: isChrome() !== 'Mobile',
    menuType: null,
    direction: 'left',
    fab: true,
    hover: false,
    transition: 'slide-x-reverse-transition',
  }),
  methods: {
    async sendMessageToTape() {
      const extensionID = 'cooadaolpinhaghnkkimdadhahbjjocb'
      if (this.currentUser && this.currentUser.uid) {
        let result = await getUserToken(this, this.currentUser.uid)

        try {
          chrome.runtime.sendMessage(extensionID, { type: 'tape', userToken: result.token }, (response) => {
            // console.error('sendMessageToTape Tape!!!!!!!!!!!!!!!', result)
            // console.log(response)
          })
        } catch (error) {
          // handle the error silently
        }
      }
    },

    resetScroll() {
      setTimeout(() => {
        try {
          window.scrollTo({
            top: 0,
            left: 0,
          })
        } catch (e) {
          console.log()
        }
      }, 1)
    },
    closeDrawer() {
      this.drawer = !this.drawer
      this.$refs.sideBar.getDrawer = this.drawer
    },
    setDrawer(val) {
      this.drawer = val
    },
    openDialog(type) {
      if (type === 'Setting') {
        this.settingVisible = true
      } else if (type === 'Slot') {
        this.slotVisible = true
      } else if (type === 'Leave') {
        this.isLeaveDialog = true
      } else {
        this.manageVisible = true
      }
    },
    closeDialog(type) {
      if (type === 'Setting') {
        this.settingVisible = false
      } else if (type === 'Slot') {
        this.slotVisible = false
      } else if (type === 'Manage') {
        this.manageVisible = false
      } else if (type === 'Leave') {
        this.isLeaveDialog = false
      } else {
        this.settingVisible = false
      }
    },
  },
  computed: {
    ...mapGetters([
      'assignedInfo',
      'selectedWsInfo',
      'userInfo',
      'userName',
      'chList',
      'selectedCh',
      'isWsManager',
      'isWsOwner',
      'currentUser',
    ]),
    computedSelectedCh() {
      return this.selectedCh ?? {}
    },
    computedUserInfo() {
      return this.userInfo ?? {}
    },
    isChOwner() {
      return this.userInfo && this.selectedCh && this.userInfo['userId'] === this.selectedCh['chPermission']
    },
    chk_isLoading() {
      return this.$store.getters.chk_isLoading ? this.$store.getters.chk_isLoading : false
    },
    isInIframe() {
      return window.location != window.parent.location
      // return true
    },
  },
}
</script>

<style>
h1.logo {
  position: relative;
  width: 108px;
  height: 30px;
  padding-left: 62px;
  /* background: url('~@/assets/img/tape-logo-typo.png') no-repeat right;
  background-size: 43px 17px;
  font-size: 0;
  text-indent: -9999px; */
  font-size: 18px;
  font-weight: 900;
  line-height: 30px;
  overflow: hidden;
  cursor: pointer;
  color: white;
}

h1.logo:before {
  content: '';
  position: absolute;
  left: 0;
  width: 48px;
  height: 30px;
  background: url('~@/assets/img/tape-logo.png') no-repeat center;
  background-size: cover;
}

@media (max-width: 960px) {
  h1.logo {
    width: 32px;
    height: 20px;
    padding-left: 42px;
  }
  h1.logo:before {
    width: 32px;
    height: 20px;
    background: url('~@/assets/img/tape-logo.png') no-repeat center;
    background-size: cover;
  }
}

.video img {
  width: 100%;
  position: relative;
}

.video img {
  width: 100%;
  position: relative;
}

.video {
  position: relative;
}

.card-title {
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  word-break: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  letter-spacing: 0;
}

.card-sub-title {
  font-size: 11px;
  color: #999999;
  white-space: nowrap;
  word-break: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 14px;
  padding-bottom: 4px;
  letter-spacing: 0;
}

.card-detail-title {
  white-space: nowrap;
  word-break: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 600;
  font-size: 16px;
  color: white;
  width: 100%;
}

.thumbnail-empty-logo {
  position: absolute;
  top: 26%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.thumbnail-mobile-logo {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.thumbnail-logo {
  position: absolute;
  top: 35%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.thumbnail-logo2 {
  position: absolute;
  top: 50%;
  left: 55%;
  transform: translate(-50%, -50%);
}

.play-button-outer {
  width: calc(100% - 6px);
  height: 155px;
  background-color: rgba(16, 16, 16, 0.5);
  cursor: pointer;
  position: absolute;
  /* border-radius: 24px 24px 0 0; */
  top: 81.5px;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: all 0.3s;
  border-radius: 8px;
}

.play-button {
  margin: 0 auto;
  top: 70px;
  position: relative;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 9px 0 12px 17px;
  border-color: transparent transparent transparent #ddd;
  opacity: 1;
}

.play-button-outer-mobile {
  width: 70px;
  height: 50px;
  background-color: #666666;
  cursor: pointer;
  border-radius: 20%;
  position: absolute;
  top: 50px;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
}

.play-button-mobile {
  margin: 0 auto;
  top: 15px;
  position: relative;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 9px 0 12px 17px;
  border-color: transparent transparent transparent #ff464f;
  opacity: 1;
}

/* div.v-card:hover .play-button-outer {
  opacity: 0.9;
}

div.v-card:hover .play-button-outer-mobile {
  opacity: 0.9;
} */

.ListItem {
  color: #ffc107 !important;
}

.record-layout {
  display: flex;
  /* position: absolute; */
  max-width: 100%;
  /* max-width: 1280px; */
  /* max-height: 720px; */
  aspect-ratio: 16 / 9;
  max-height: 100%;
  /* top: 45%;
  left: 50%; */
  /* transform: translate(-50%, -50%); */
  /* border-radius: 20px; */
  /* overflow: hidden; */
}
.non-record-layout {
  display: flex;
  width: 100%;
  max-height: 100%;
}
.embed-layout {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.record-layout-notScreen {
  display: flex;
  max-width: 100%;
  max-height: 100%;
}
.countdown-layout {
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* 
 * 펼쳐졌을 때 Background Layout
 */
.floating-all-layout {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100vw;
  height: 100vh;
  z-index: 200;
  background-color: rgba(16, 16, 16, 0.8);
}

.record-on {
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 25px;
  bottom: 25px;
  left: 25px;
  right: 25px;
  width: calc(100vw - 50px);
  height: calc(100vh - 50px);
  z-index: 200;
  background-color: #1a272e;
  border: 1px solid #475e69;
  border-radius: 5px;
}

.record-off {
  display: none;
}
/* 
 * 기본 Floating Layout
 */
.floating-layout {
  background: transparent;
  max-width: 600px;
  z-index: 202;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 54px;
  padding: 0;
  /* padding-left: 20px;
  padding-right: 20px; */
}

/* 
 * 펼쳤을 때 Floating Layout
 */
.floating-layout-active,
.floating-layout-active-hide {
  background: transparent;
  /* max-width: 600px; */
  width: 100%;
  /* height: 65px; */
  z-index: 200;
  /* position: absolute; */
  /* bottom: 54px;
  left: 50%;
  transform: translate(-50%, 0); */
  /* margin-top: 0 !important; */
  /* padding-left: 20px;
  padding-right: 20px; */
  border: 1px solid #475e69;
  overflow: auto;
  background-color: #161d21;
  border-radius: 5px;
}
.floating-layout-non-screen {
  /* border: unset; */
  /* background-color: transparent; */
  position: relative;
}

.floating-menu {
  /* max-width: 600px; */
  /* width: 100%; */
  /* height: 65px; */
  z-index: 200;
  /* border-radius: 15px; */
  /* position: absolute; */
  /* margin: 0 auto; */
  /* background: rgba(65, 227, 162, 0.85); */
  height: 100%;
}

.floating-method {
  /* position: fixed; */
  background: transparent;
  /* max-width: 600px; */
  width: 100%;
  height: auto;
  z-index: 200;
  /* bottom: 0; */
  padding: 0 0 20px 0;
}
.floating-method-record {
  /* position: fixed; */
  background: transparent;
  max-width: 600px;
  width: 100%;
  height: auto;
  z-index: 200;
  /* bottom: 0; */
  padding: 0 0 20px 0;
}

.floating-menu i {
  color: white;
  font-size: 25px;
}

.floating-menu .svg-inline--fa {
  color: white;
  font-size: 25px;
}

.record-layout-preview {
  width: 100%;
  height: 100%;
  /* height: -webkit-fill-available; */
}
.preview-layout {
  height: 100%;
  text-align: center;
  text-align: -webkit-center;
}
@media (max-width: 800px) {
  .preview-layout {
    min-width: 340px !important;
  }
}

.dialog2 >>> .el-dialog {
  background-color: #21343b !important;
}

.dialog2 >>> .el-dialog__body {
  background: #21343b !important;
  min-width: 250px;
  max-width: 250px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.dialog2 >>> .el-dialog__header {
  background: #21343b !important;
  min-width: 250px;
  max-width: 250px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.dialog2 >>> .el-dialog__title {
  color: white;
  min-width: 250px;
  max-width: 250px;
}
@media (max-width: 800px) {
  .container-main {
    width: 100% !important;
  }
}

header {
  z-index: 199 !important;
}

.container-skeleton {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.v-skeleton-loader__table-heading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
}

.container-skeleton .v-skeleton-loader__image {
  border-radius: 24px 24px 0 0;
  max-width: 166vh;
  width: 93vw;
  height: 100%;
  aspect-ratio: 16 / 8;
  margin-top: 60px;
  margin-left: 40px;
}
.container-skeleton .v-skeleton-loader__card-heading {
  border-radius: 0 0 24px 24px;
  max-width: 166vh;
  width: 93vw;
  height: 125px;
  margin-left: 40px;
}
@media (max-width: 1263px) {
  .container-skeleton {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    height: 100%;
    margin-top: 55px;
  }
  .container-skeleton .v-skeleton-loader__image {
    margin-top: 0;
    border-radius: 0;
    width: 100vw;
    margin-left: 0;
  }
  .container-skeleton .v-skeleton-loader__card-heading {
    border-radius: 0 0 24px 24px;
    width: 100vw;
    margin-left: 0;
  }
}
@media (max-height: 1000px) {
  .container-skeleton .v-skeleton-loader__image {
    max-width: 160vh;
  }
}
@media (max-height: 900px) {
  .container-skeleton .v-skeleton-loader__image {
    aspect-ratio: 16 / 7.8;
    max-width: 155vh;
  }
  .container-skeleton .v-skeleton-loader__card-heading {
    max-width: 155vh;
    height: 110px;
  }
}
@media (max-height: 700px) {
  .container-skeleton .v-skeleton-loader__image {
    aspect-ratio: 16 / 7;
    max-width: 155vh;
  }
  .container-skeleton .v-skeleton-loader__card-heading {
    max-width: 155vh;
    height: 90px;
  }
}
.app-bar-icon i {
  width: 20px !important;
  height: 20px !important;
  font-size: 20px !important;
}
/* @media (max-height: 600px) {
  .app-bar-icon i {
    width: 20px !important;
    height: 20px !important;
    font-size: 20px !important;
  }
} */
</style>
